export const _translations = {
	legacy: false, // using the Composition API
	locale: 'de', // default locale; you can change this as needed
	messages: {
		de: {
			project: {
				noProjectFound: 'Kein Projekt gefunden',
				project: 'Projekt',
				name: 'Name',
				shortName: 'Kurzname',
				projectNumber: 'Projekt Nummer',
				comments: 'Kommentare',
				locations: 'Standorte',
				isArchived: 'Archiviert',
				update: 'Aktualisieren',
				general: 'Allgemein',
				users: 'Benutzer',
				alertEquations: 'Alarm-Gleichungen',
				alertGraphs: 'Alarm-Grafiken',
				alerts: 'Warnungen',
				map: 'Karte',
				hubs: 'Hubs',
				comapps: 'ComApps',
				components: 'Komponenten',
				files: 'Dateien',
				deleteProject: 'Projekt löschen',
				addNewProject: 'Neues Projekt hinzufügen',
				save: 'Speichern',
				image: 'Bild',
				pin: '',
				status: 'Status',
				created: 'Erstellt',
				showArchived: 'Archivierte anzeigen',
				filter: 'Filtern...',
				assignLocation: 'Standort zuweisen',
				addNewLocation: 'Neuen Standort hinzufügen',
				assignExisting: 'Vorhandenen zuweisen',
				location: 'Standort',
				requiredName: 'Name ist erforderlich',
				requiredLocation: 'Standort ist erforderlich',
				locationAssigned: 'Standort erfolgreich zugewiesen',
				locationReassigned: 'Standort erfolgreich neu zugewiesen',
				archive: 'Archiv',
				AllProjects: 'Alle Projekte',
				countHubs: 'Anzahl Hubs',
				countModules: 'Anzahl Module',
				countComapps: 'Anzahl ComApps',
				hidden: 'versteckt',
				noHubs: 'Keine Hubs',
				noModules: 'Keine Module',
				noComapps: 'Keine ComApps',
				graphs: 'Graphen',
				noGraphs: 'Keine Graphen',
				lastLog: 'letztes Log',
				lastOnline: 'zuletzt online',
				filesPerMonth: 'Dateien/Monat',
				projectLabel: 'Projekt', // for select label
				assign: 'Vorhandenen zuweisen',
				addnew: 'Neuen Standort hinzufügen',
				confirmDelete: 'Projekt wirklich löschen?',
				successProjectDeleted: 'Projekt erfolgreich gelöscht',
				successProjectUpdated: 'Projekt erfolgreich aktualisiert',
				emptyAssigned: 'Derzeit sind keine Projekte zugewiesen.',
				emptyFiltered: 'Keine Projekte für den aktuellen Filter gefunden.',
				reload: 'Ansicht neu laden',
				assignedUsers: 'Zugewiesene Benutzer',
				assignedUsersHelp: 'Personen mit Zugriff auf dieses Projekt.',
				userCount: '{count} Benutzer',
				addUserToProject: 'Benutzer zum Projekt hinzufügen',
				addUserHelp: 'Vorhandenen Benutzer auswählen, um Zugriff zu erteilen.',
				selectUserPlaceholder: 'Benutzer suchen oder auswählen',
				noAssignedUsers: 'Diesem Projekt sind noch keine Benutzer zugewiesen.',
				noAvailableUsers: 'Keine weiteren Benutzer zum Hinzufügen verfügbar.',
				removeAccess: 'Zugriff entfernen',
				confirmRemoveUser: 'Soll dieser Benutzer wirklich von diesem Projekt entfernt werden?',
				addUser: 'Benutzer hinzufügen',
				userAdded: 'Benutzer dem Projekt hinzugefügt',
				userRemoved: 'Benutzer aus dem Projekt entfernt',
				updateFailed: 'Aktualisierung fehlgeschlagen',
				userNotFound: 'Benutzer nicht gefunden',
				alertGraphsTitle: 'Alarm-Grafiken',
				alertGraphsDesc:
					'Zeigt alle Graphen dieses Projekts, ihre Empfänger (Warn/Alert) und ob eine 24h-Nichtsendung aktiv ist.',
				alertGraphsGraph: 'Graph / Gleichung',
				alertGraphsLocation: 'Standort',
				alertGraphsStatus: 'Status',
				alertGraphsCase: 'Fall',
				alertGraphsRecipients: 'Empfänger',
				alertGraphsAdd: 'Externe E-Mail hinzufügen',
				alertGraphsAddPlaceholder: 'email (example.com)',
				alertGraphsAddHint: 'E-Mail wird in Kleinbuchstaben gespeichert und lokal gemerkt.',
				alertGraphsFilterPlaceholder: 'Nach Empfänger filtern',
				alertGraphsNoRecipients: 'Keine Empfänger hinterlegt',
				alertGraphsNoLocation: 'Kein Standort',
				alertGraphsNoCase: 'Kein Fall',
				alertGraphsEmpty: 'Keine Graphen für dieses Projekt/Standort gefunden.',
				alertGraphsRemoveEmail: 'E-Mail entfernen',
				alertGraphsRemoveRecipient: 'Empfänger entfernen',
				alertGraphsConfirmRemoveRecipient: 'Diesen Benutzer für diesen Graphen entfernen?',
				alertGraphsConfirmRemoveEmail: 'Diese externe E-Mail wirklich entfernen?',
				alertGraphsAddModalTitle: 'Empfänger hinzufügen: {graph}',
				alertGraphsAddUser: 'Benutzer hinzufügen',
				alertGraphsUserPlaceholder: 'Nach Benutzer suchen',
				alertGraphsNoUsers: 'Keine passenden Benutzer',
				alertGraphsAddEmail: 'Externe E-Mail',
				alertGraphsToggleEquations: 'Sensoren/Gleichungen anzeigen',
				alertGraphsListSensors: 'Sensoren anzeigen',
				alertGraphsShowAlertedSensors: 'Nur alarmierte Sensoren umschalten',
				alertGraphsShowAllSensors: 'Alle Sensoren umschalten',
				alertGraphsHideSensors: 'Sensoren ausblenden',
				alertGraphsNoAlertedSensors: 'Keine alarmierten Sensoren',
				alertGraphsHiddenCleanup: 'Wird automatisch bereinigt.',
			},
		},
		en: {
			project: {
				noProjectFound: 'No project found',
				project: 'Project',
				name: 'Name',
				shortName: 'Short Name',
				projectNumber: 'Project Number',
				comments: 'Comments',
				locations: 'Locations',
				isArchived: 'Archived',
				update: 'Update',
				general: 'General',
				users: 'Users',
				alertEquations: 'Alert Equations',
				alertGraphs: 'Alert Graphs',
				alerts: 'Alerts',
				map: 'Map',
				hubs: 'Hubs',
				comapps: 'ComApps',
				components: 'Components',
				files: 'Files',
				deleteProject: 'Delete Project',
				addNewProject: 'Add New Project',
				save: 'Save',
				image: 'Image',
				pin: '',
				status: 'Status',
				created: 'Created',
				showArchived: 'Show archived',
				filter: 'Filter...',
				assignLocation: 'Assign Location',
				addNewLocation: 'Add New Location',
				assignExisting: 'Assign Existing',
				location: 'Location',
				requiredName: 'Name is required',
				requiredLocation: 'Location is required',
				locationAssigned: 'Location assigned successfully',
				locationReassigned: 'Location re-assigned successfully',
				archive: 'Archive',
				AllProjects: 'All Projects',
				countHubs: 'Hub Count',
				countModules: 'Module Count',
				countComapps: 'ComApp Count',
				hidden: 'hidden',
				noHubs: 'No Hubs',
				noModules: 'No Modules',
				noComapps: 'No ComApps',
				graphs: 'Graphs',
				noGraphs: 'No graphs',
				lastLog: 'last log',
				lastOnline: 'last online',
				filesPerMonth: 'files/month',
				projectLabel: 'Project', // for select label
				assign: 'Assign Existing',
				addnew: 'Add New Location',
				confirmDelete: 'Really delete project?',
				successProjectDeleted: 'Project deleted successfully',
				successProjectUpdated: 'Project updated successfully',
				emptyAssigned: 'There are no projects assigned to you for now!',
				emptyFiltered: 'No projects found for the current filter!',
				reload: 'Reload view',
				assignedUsers: 'Assigned Users',
				assignedUsersHelp: 'People who currently have access to this project.',
				userCount: '{count} users',
				addUserToProject: 'Add User to Project',
				addUserHelp: 'Select an existing user to grant access.',
				selectUserPlaceholder: 'Search or select a user',
				noAssignedUsers: 'No users are assigned to this project yet.',
				noAvailableUsers: 'No more users are available to add.',
				removeAccess: 'Remove access',
				confirmRemoveUser: 'Remove this user from the project?',
				addUser: 'Add user',
				userAdded: 'User added to project',
				userRemoved: 'User removed from project',
				updateFailed: 'Update failed',
				userNotFound: 'User not found',
				alertGraphsTitle: 'Alert Graphs',
				alertGraphsDesc:
					'Lists all graphs in this project, which receive 24h no-sending alerts, and whether alerts are active.',
				alertGraphsGraph: 'Graph / Equation',
				alertGraphsLocation: 'Location',
				alertGraphsStatus: 'Status',
				alertGraphsCase: 'Case',
				alertGraphsRecipients: 'Recipients',
				alertGraphsAdd: 'Add external email',
				alertGraphsAddPlaceholder: 'email (example.com)',
				alertGraphsAddHint: '',
				alertGraphsFilterPlaceholder: 'Filter by recipient',
				alertGraphsNoRecipients: 'No recipients yet',
				alertGraphsNoLocation: 'No location',
				alertGraphsNoCase: 'No case',
				alertGraphsEmpty: 'No graphs found for this project/location.',
				alertGraphsRemoveEmail: 'Remove email',
				alertGraphsRemoveRecipient: 'Remove recipient',
				alertGraphsConfirmRemoveRecipient: 'Remove this user from this graph?',
				alertGraphsConfirmRemoveEmail: 'Remove this external email?',
				alertGraphsAddModalTitle: 'Add recipient for {graph}',
				alertGraphsAddUser: 'Add user',
				alertGraphsUserPlaceholder: 'Search user',
				alertGraphsNoUsers: 'No matching users',
				alertGraphsAddEmail: 'External email',
				alertGraphsToggleEquations: 'Show sensors/equations',
				alertGraphsListSensors: 'List sensors',
				alertGraphsShowAlertedSensors: 'Toggle only alerted sensors',
				alertGraphsShowAllSensors: 'Toggle all sensors',
				alertGraphsHideSensors: 'Hide sensors',
				alertGraphsNoAlertedSensors: 'No alerted sensors',
				alertGraphsHiddenCleanup: 'This will be cleaned up automatically.',
			},
		},
	},
}
